import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarCheck, X } from "lucide-react";
import { BOOKSY_URL, WHATSAPP_URL } from "@/data/content";

const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
    </svg>
);

export const FloatingCTA = () => {
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const show = window.scrollY > 480;
            setVisible(show);
            if (!show) setOpen(false);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="floating-cta-group"
                    initial={{ opacity: 0, y: 24, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 24, scale: 0.95 }}
                    transition={{ duration: 0.25, ease: "easeOut" }}
                    className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3"
                >
                    <AnimatePresence>
                        {open && (
                            <motion.div
                                key="fab-options"
                                initial={{ opacity: 0, y: 12, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 12, scale: 0.95 }}
                                transition={{ duration: 0.18, ease: "easeOut" }}
                                className="flex flex-col items-end gap-3"
                            >
                                <a
                                    href={WHATSAPP_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="floating-whatsapp-btn"
                                    className="inline-flex items-center gap-2 rounded-full bg-ink py-3 pl-4 pr-5 text-sm font-bold text-white shadow-2xl shadow-black/40 ring-1 ring-white/15 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#222222]"
                                >
                                    <WhatsAppIcon className="h-5 w-5 text-gold" />
                                    WhatsApp
                                </a>
                                <a
                                    href={BOOKSY_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="floating-booking-btn"
                                    className="inline-flex items-center gap-2 rounded-full bg-gold py-3 pl-4 pr-5 text-sm font-bold text-ink shadow-2xl shadow-black/40 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#a88a1e]"
                                >
                                    <CalendarCheck className="h-5 w-5" />
                                    Reservar Cita
                                </a>
                            </motion.div>
                        )}
                    </AnimatePresence>
                    <button
                        type="button"
                        data-testid="floating-menu-btn"
                        aria-label={open ? "Cerrar accesos rápidos" : "Abrir accesos rápidos"}
                        aria-expanded={open}
                        onClick={() => setOpen((v) => !v)}
                        className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gold text-ink shadow-2xl shadow-black/40 ring-1 ring-black/20 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#a88a1e]"
                    >
                        {open ? <X className="h-6 w-6" /> : <CalendarCheck className="h-6 w-6" />}
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
